__webpack_public_path__ = '/front_assets/'; // eslint-disable-line

Number.isNaN = Number.isNaN || function isNaNPolyfill(value) {
  return value !== value; // eslint-disable-line no-self-compare
};
